import React, { useState } from 'react';
import { Input, Select, Space, Typography, Checkbox } from 'antd';
import { fetchData } from '../../service/dataServices';
import TranslatableInput from '../../components/form/TranslatableInput';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export default function FormField({ fieldData, onChange }) {
  const { t } = useTranslation();
  const [dropdowns, setDropdowns] = useState([]);
  const [enableDropdownType, setEnableDropdownType] = useState(false)

  const isNameInvalid = !fieldData.name || (typeof fieldData.name === 'object'
    ? !fieldData.name.en?.trim() && !fieldData.name.ar?.trim()
    : fieldData.name.trim() === "");
  const isTypeInvalid = !fieldData.type;

  fetchData('/api/dropdowns/types', (resp) => setDropdowns(resp.map(i => { return { value: i.id, label: i.title } })));

  function onDataTypeSelected(val) {
    onChange('type', val)
    if (val === 'dropdown') {
      setEnableDropdownType(true);
      console.log('dropdowns', dropdowns)
    } else {
      setEnableDropdownType(false);
    }
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={12}>
      {/* Field Name Input */}
      <Space direction="vertical" style={{ width: '100%' }} size={2}>
        <Text type="secondary" style={{ fontSize: '11px' }}>{t('formBuilder.fieldName')}</Text>
        <TranslatableInput
          value={fieldData.name || {}}
          onChange={(val) => onChange('name', val)}
          placeholder={{ en: 'e.g. Carpet Thickness', ar: 'مثال: سمكة السجاد' }}
          status={isNameInvalid ? 'error' : ''}
        />
      </Space>

      {/* Data Type Selection */}
      <Space direction="vertical" style={{ width: '100%' }} size={2}>
        <Text type="secondary" style={{ fontSize: '11px' }}>{t('formBuilder.dataType')}</Text>
        <Select
          style={{ width: '100%' }}
          status={isTypeInvalid ? "error" : ""}
          placeholder={t('formBuilder.selectType')}
          value={fieldData.type || undefined}
          onChange={onDataTypeSelected}
          options={[
            { value: 'text', label: t('formBuilder.textType') },
            { value: 'long_text', label: t('formBuilder.longText') },
            { value: 'number', label: t('formBuilder.numberType') },
            { value: 'date', label: t('formBuilder.dateType') },
            { value: 'boolean', label: t('formBuilder.checkboxType') },
            { value: 'single_photo', label: t('formBuilder.singlePhoto') },
            { value: 'multiple_photos', label: t('formBuilder.multiplePhotos') },
            { value: 'pdf_upload', label: t('formBuilder.pdfUpload') },
            { value: 'model_3d', label: t('formBuilder.model3d', '3D Model (GLB)') },
            { value: 'dropdown', label: t('formBuilder.dropdown') },
            { value: 'user_dropdown', label: t('formBuilder.userDropdown') },
          ]}
        />
      </Space>

      {/* Required Checkbox */}
      <Checkbox
        checked={fieldData.isRequired}
        onChange={(e) => onChange('isRequired', e.target.checked)}
      >
        {t('formBuilder.requiredField')}
      </Checkbox>

      {/* showOnTable Checkbox */}
      <Checkbox
        checked={fieldData.showOnTable}
        onChange={(e) => onChange('showOnTable', e.target.checked)}
      >
        {t('formBuilder.showOnTable')}
      </Checkbox>

      {/* useForTableFilter Checkbox */}
      <Checkbox
        checked={fieldData.useForTableFilter}
        onChange={(e) => onChange('useForTableFilter', e.target.checked)}
      >
        {t('formBuilder.useForFilter')}
      </Checkbox>

      {enableDropdownType && (
        <Select
          style={{ width: '100%' }}
          placeholder={t('formBuilder.selectDropdownType')}
          value={fieldData.dropdownType || undefined}
          onChange={(val) => onChange('dropdownType', val)}
          options={dropdowns}
        />
      )}
    </Space>
  );
}